import { Pipe, PipeTransform } from "@angular/core";
import { App_FormFieldCasesDynamiques, App_FormFieldCheckbox, App_FormFieldDrawing, App_FormFieldInputNumber, App_FormFieldInputText/*, App_FormFieldListUser*/, App_FormFieldListe, App_FormFieldRadio, App_FormFieldTextArea, App_FormSketchField } from "src/app/utils/interfaces";

import { Type_CustomField, Type_Field, Type_FieldOrLabel, Type_Label } from 'src/app/utils/types';
import { instanceOfCasesDynamiques, instanceOfCustomField, instanceOfFieldCheckbox, instanceOfFieldDrawing, instanceOfFieldInputNumber, instanceOfFieldInputText, instanceOfFieldLabel/*, instanceOfFieldListUser*/, instanceOfFieldListe, instanceOfFieldRadio, instanceOfFieldtextArea, instanceOfTrueField, readonlyRuleApplies } from 'src/app/utils/utils';


@Pipe({
  name: 'asLabelPipe'
})
export class AsLabelPipe implements PipeTransform {
  transform(object: Type_FieldOrLabel): Type_Label | undefined {
    return instanceOfFieldLabel(object)
      ? object as Type_Label
      : undefined;
  }
}

@Pipe({
  name: 'asFieldPipe'
})
export class AsFieldPipe implements PipeTransform {
  transform(object: Type_FieldOrLabel): Type_Field | undefined {
    return instanceOfTrueField(object)
      ? object as Type_Field
      : undefined;
  }
}

@Pipe({
  name: 'asCustomFieldPipe'
})
export class AsCustomFieldPipe implements PipeTransform {
  transform(object: Type_FieldOrLabel): Type_CustomField | undefined {
    return instanceOfCustomField(object)
      ? object as Type_CustomField
      : undefined;
  }
}

@Pipe({
  name: 'asCheckboxPipe'
})
export class AsCheckboxPipe implements PipeTransform {
  transform(object: Type_Field): App_FormFieldCheckbox | undefined {
    return instanceOfFieldCheckbox(object)
      ? object as App_FormFieldCheckbox
      : undefined;
  }
}

@Pipe({
  name: 'asRadioPipe'
})
export class AsRadioPipe implements PipeTransform {
  transform(object: Type_Field): App_FormFieldRadio | undefined {
    return instanceOfFieldRadio(object)
      ? object as App_FormFieldRadio
      : undefined;
  }
}

@Pipe({
  name: 'asTextAreaPipe'
})
export class AsTextAreaPipe implements PipeTransform {
  transform(object: Type_Field): App_FormFieldTextArea | undefined {
    return instanceOfFieldtextArea(object)
      ? object as App_FormFieldTextArea
      : undefined;
  }
}

@Pipe({
  name: 'asInputTextPipe'
})
export class AsInputTextPipe implements PipeTransform {
  transform(object: Type_Field): App_FormFieldInputText | undefined {
    return instanceOfFieldInputText(object)
      ? object as App_FormFieldInputText
      : undefined;
  }
}

@Pipe({
  name: 'asInputNumberPipe'
})
export class AsInputNumberPipe implements PipeTransform {
  transform(object: Type_Field): App_FormFieldInputNumber | undefined {
    return instanceOfFieldInputNumber(object)
      ? object as App_FormFieldInputNumber
      : undefined;
  }
}

@Pipe({
  name: 'asDrawingPipe'
})
export class AsDrawingPipe implements PipeTransform {
  transform(object: Type_Field): App_FormFieldDrawing | undefined {
    return instanceOfFieldDrawing(object)
      ? object as App_FormFieldDrawing
      : undefined;
  }
}

@Pipe({
  name: 'asCasesDynamiquesPipe'
})
export class AsCasesDynamiquesPipe implements PipeTransform {
  transform(object: Type_Field): App_FormFieldCasesDynamiques | undefined {
    return instanceOfCasesDynamiques(object)
      ? object as App_FormFieldCasesDynamiques
      : undefined;
  }
}

/*
@Pipe({
  name: 'asListUserPipe'
})
export class AsListUserPipe implements PipeTransform {
  transform(object: Type_Field): App_FormFieldListUser | undefined {
    return instanceOfFieldListUser(object)
      ? object as App_FormFieldListUser
      : undefined;
  }
}
  */

@Pipe({
  name: 'asListePipe'
})
export class AsListePipe implements PipeTransform {
  transform(object: Type_Field): App_FormFieldListe | undefined {
    return instanceOfFieldListe(object)
      ? object as App_FormFieldListe
      : undefined;
  }
}

@Pipe({
  name: 'readonlyByRule',
  // laisse standalone à false car on le déclare dans le module
})
export class ReadonlyByRulePipe implements PipeTransform {
  transform(rule: number | null | undefined, etatId: number | null | undefined): boolean {
    return readonlyRuleApplies(rule, etatId);
  }
}
